import { motion } from "framer-motion";
import { PROFILE, SKILLS, CERTS } from "../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const About = () => (
  <section data-testid="about-section" id="about" className="relative py-28 lg:py-40 bg-charcoal-900">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
      <div className="lg:col-span-5">
        <Reveal>
          <div className="relative w-full max-w-md mx-auto">
            <div className="absolute -inset-3 border border-gold/25 rounded-[2rem] -translate-x-3 -translate-y-3" />
            <div className="relative overflow-hidden rounded-[2rem] aspect-[4/5] bg-charcoal-800">
              <img
                src={PROFILE.aboutImage}
                alt={PROFILE.name}
                data-testid="about-portrait"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/60 to-transparent" />
            </div>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <Reveal>
          <Eyebrow testid="about-eyebrow">The Founder</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-6 leading-[1.1]">
            The partner founders call <span className="italic text-gold-gradient">before the agency.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-cream/55 mt-6 text-base sm:text-lg leading-relaxed">
            {PROFILE.aboutTagline}
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <p className="text-cream/55 mt-4 text-base sm:text-lg leading-relaxed">
            I've managed multi-crore budgets, built teams and P&amp;Ls, and delivered 5x–10x
            returns for brands in aviation, FMCG, technology and D2C. No hand-offs, no fluff —
            just senior judgement and an operator who owns the outcome with you.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-10">
            <p className="text-xs uppercase tracking-[0.3em] text-gold/70 mb-4">Expertise</p>
            <div className="flex flex-wrap gap-2.5">
              {SKILLS.map((s, i) => (
                <span
                  key={i}
                  className="px-4 py-2 rounded-full border border-white/10 text-cream/70 text-xs sm:text-sm hover:border-gold/50 hover:text-cream transition-colors"
                >
                  {s}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.4}>
          <div className="mt-8">
            <p className="text-xs uppercase tracking-[0.3em] text-gold/70 mb-4">Certified</p>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              {CERTS.map((c, i) => (
                <span key={i} className="text-cream/50 text-sm">{c}</span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
